/* eslint-disable react/jsx-props-no-spreading */
import { set, get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import objectDeepCopy from 'utils/object-deep-copy';

const EntityDataContext = React.createContext();

export default function FormComponent({
    children, className, source, onFormChange, ParentComponent,
})
{
    const contextValue = useMemo(() =>
    {
        const errors = source.errorsBag.flatten();
        const sourceData = source.data;

        const onChange = (value, path) =>
        {
            if (!path)
            {
                throw Error('You need to specify a path when using form controls inside form');
            }

            const form = objectDeepCopy(source);

            form.deleteError(path);

            set(form.data, path, value);

            onFormChange(form, path);
        };

        return {
            errors,
            source: sourceData,
            onChange,
        };
    }, [source, onFormChange]);

    return (
        <EntityDataContext.Provider
            value={contextValue}
        >
            <ParentComponent className={className}>{ children }</ParentComponent>
        </EntityDataContext.Provider>
    );
}
function ParentComponentElement(props)
{
    return <div className={props.className}>{ props.children }</div>;
}

ParentComponentElement.propTypes = {
    className: PropTypes.string,
    children: PropTypes.any,
};

FormComponent.defaultProps = {
    ParentComponent: ParentComponentElement,
};

FormComponent.propTypes = {
    children: PropTypes.node,
    className: PropTypes.string,
    onFormChange: PropTypes.func.isRequired,
    source: PropTypes.object.isRequired,
    ParentComponent: PropTypes.func,
};

/* eslint-disable react/prop-types */
export function withFormHandler(Component)
{
    return function (props)
    {
        return (
            <EntityDataContext.Consumer>
                {(formProps) =>
                {
                    const {
                        onChange, options, placeholder, readOnly, value, styles, className, onKeyDown, disabled,
                    } = props;

                    if (!formProps)
                    {
                        return (
                            <Component disabled={disabled} className={className || ''} options={options} placeholder={placeholder} onChange={onChange} value={value} styles={styles} />
                        );
                    }

                    const source = props.source || formProps.source;
                    const { path } = props;
                    const errors = props.error || formProps.errors[path];
                    const sourceValue = get(source, path, null);

                    return (
                        <Component
                            {...props}
                            className={className || ''}
                            error={errors}
                            path={path}
                            value={value || sourceValue}
                            onChange={onChange || formProps.onChange}
                            onKeyDown={onKeyDown || formProps.onKeyDown}
                            options={options}
                            readOnly={readOnly}
                            styles={styles}
                            placeholder={placeholder || ''}
                        />
                    );
                }}
            </EntityDataContext.Consumer>
        );
    };
}
